module.exports = __webpack_public_path__ + "static/40-chances-12a87c4a047bb30403aa818cb5048c75.jpg";